<template>
  <div>
    <van-overlay :show="show" @click="show = false">
      <div class="wrapper" @click.stop>
        <img src="../../../../../assets/images/icon_action.png" alt="" />
        <div class="tip">
          <p class="color-text">左右滑动</p>
          <p>可切换实习计划</p>
        </div>
        <div class="button">我知道了</div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
export default {
  data() {
    return {
      show: true,
    }
  },
}
</script>

<style lang="less" scoped>
.wrapper {
  padding-top: 177px;
  img {
    margin: 0 auto;
    width: 121px;
    height: 68px;
    display: block;
  }
}

.block {
  width: 120px;
  height: 120px;
  background-color: #fff;
}
.tip {
  margin-top: 40px;
  display: flex;
  justify-content: center;
  p {
    font-size: 14px;
    color: #fff;
  }
  .color-text {
    color: #fe923f;
    margin-right: 15px;
  }
}
.button {
  width: 86px;
  height: 34px;
  border: 1px solid #ffffff;
  border-radius: 17px;
  font-size: 14px;
  color: #ffffff;
  text-align: center;
  line-height: 34px;
  margin: 50px auto;
}
.button:active {
  background-color: rgba(0, 0, 0, 0.1);
  opacity: 0.7;
}
.van-overlay {
  background-color: rgba(0, 0, 0, 0.8);
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/teacher/internship/components/overlay.vue